"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductMenuDetailSearchModel = instanceOfProductMenuDetailSearchModel;
exports.ProductMenuDetailSearchModelFromJSON = ProductMenuDetailSearchModelFromJSON;
exports.ProductMenuDetailSearchModelFromJSONTyped = ProductMenuDetailSearchModelFromJSONTyped;
exports.ProductMenuDetailSearchModelToJSON = ProductMenuDetailSearchModelToJSON;
exports.ProductMenuDetailSearchModelToJSONTyped = ProductMenuDetailSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductMenuDetailSearchModel interface.
 */
function instanceOfProductMenuDetailSearchModel(value) {
    return true;
}
function ProductMenuDetailSearchModelFromJSON(json) {
    return ProductMenuDetailSearchModelFromJSONTyped(json, false);
}
function ProductMenuDetailSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'venderName': json['venderName'] == null ? undefined : json['venderName'],
        'seriesName': json['seriesName'] == null ? undefined : json['seriesName'],
        'name': json['name'] == null ? undefined : json['name'],
        'no': json['no'] == null ? undefined : json['no'],
    };
}
function ProductMenuDetailSearchModelToJSON(json) {
    return ProductMenuDetailSearchModelToJSONTyped(json, false);
}
function ProductMenuDetailSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'venderName': value['venderName'],
        'seriesName': value['seriesName'],
        'name': value['name'],
        'no': value['no'],
    };
}
